// Client-side UI state types (distinct from the API payload types in api.ts).

// The sidebar's reconciliation controls. Mapped to ReconSettings at reconcile time.
export interface SidebarSettings {
  tolerance: number;
  tolPremium: number;
  tolCommission: number;
  usdRate: number;
  eurRate: number;
  periodFrom?: string;
  periodTo?: string;
  // The user emptied a From that had a value (a per-insurer default or their own).
  // Sent to the engine so it drops its cri_period_floor default and really reconciles
  // the whole ledger — a blank periodFrom alone cannot mean this, since an untouched
  // first load is blank too. Reset whenever a From is set again.
  periodFromCleared?: boolean;
  // The user emptied a To that the Run dialog had SEEDED with the chosen month-end.
  // That seed is display-only (periodTo stays ""), so clearing it leaves periodTo
  // unchanged — the re-run key never moves and nothing re-runs. This flag is the
  // signal that the gesture happened: it moves the key AND retires the recon_month
  // override, which is what actually re-imposed the cutoff. Reset when a To is set.
  periodToCleared?: boolean;
}

// Finance's standing USD->AED rate. Mirrors backend.constants.DEFAULT_USD_TO_AED_RATE
// — keep the two in step; the backend value is what governs if the field is absent.
export const DEFAULT_USD_RATE = 3.6725;

// Finance's EUR->AED rate. Mirrors backend.constants.DEFAULT_EUR_TO_AED_RATE — keep
// the two in step. Unlike USD, the AED is NOT pegged to the EUR, so this is a period
// quote finance revises rather than a standing peg; expect the override to be used.
export const DEFAULT_EUR_RATE = 4.2358;

// Defaults mirror the Streamlit sidebar (app/upload.py::_render_sidebar): every
// tolerance starts at 0.00 — reconciled only on an exact difference, exact amounts
// only for Matched — and the user loosens deliberately.
export const DEFAULT_SIDEBAR: SidebarSettings = {
  tolerance: 0.0,
  tolPremium: 0.0,
  tolCommission: 0.0,
  usdRate: DEFAULT_USD_RATE,
  eurRate: DEFAULT_EUR_RATE,
};
